import { DecisionContext, ProjectStatus } from "../common/commonDomain";
import { makeAutoObservable } from "mobx";
import { CompanyInfo } from "../../types/CompanyInfo";
import { DecisionType } from "../../common/decisions";

export type NoAuditor = {
  type: DecisionType.noAuditor;
};

export class NoAuditorForm {
  readonly type = DecisionType.noAuditor;
  readonly companyInfo: CompanyInfo;
  readonly context: DecisionContext;

  constructor(context: DecisionContext) {
    makeAutoObservable(this, { type: false }, { autoBind: true });
    this.companyInfo = context.companyInfo;
    this.context = context;
  }

  get hasAuditor(): boolean {
    return (
      this.context.projectStatus !== ProjectStatus.DRAFT ||
      this.context.companyInfo.auditorName.trim() !== ""
    );
  }

  get isProjectLocked(): boolean {
    return this.context.isLocked;
  }
}
